<template>
    <div>
        <v-container fluid class="pa-6 ">
            <DatatableV2 ref="acquisitionListDatatable" :displayTitle="false" :flat="false" :url="apiUrl" @openFormDialog="openFormDialog" />
            <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'" />
        </v-container>
    </div>
</template>

<script>
import DatatableV2 from '@/components/DatatableV2';
import GenericDataService from '@/services/GenericDataService';
import getForm from '@/mixins/mixins';

export default {
    name: "CampaignAcquisitionList",
    mixins: [getForm],
    components: {
        DatatableV2,
        FormDialogComponent: () => import("@/components/dialogs/FormDialogComponent"),
    },
    data() {
        return {
            apiUrl: "/retroplanning/list?type=MISSION&sousType=missionACQUISITION",
            form: null,
        }
    },
    methods: {
        openFormDialog() {
            this.getForm("/retroplanning/getForm?formName=@link:missionACQUISITION.params/formOpe", false, { event: 'redirectAfterAddRp', returnFullObject: true });
        },
        redirectAfterAddRp(campaign) {
            this.$router.push({ name: 'MissionDetail', params: { mission_id: campaign.id }});
        },
    },
};
</script>